import { application as initialState } from 'flux/initialState';
import { application as actions } from 'flux/actions';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.SET_LOADING_GEOLOCATION: {
      const { loadingGeolocation } = action.payload;
      return { ...state, loadingGeolocation };
    }
    case types.SET_PINCHABLE_VIEWER: {
      const { pinchableViewer } = action.payload;
      return { ...state, pinchableViewer };
    }
    case types.TOGGLE_FULLSCREEN: {
      const { active } = action.payload;
      return {
        ...state,
        fullscreen: {
          ...state.fullscreen,
          active,
        },
      };
    }
    case types.SET_GCLID: {
      const { gclid } = action.payload;
      return {
        ...state,
        gclid,
      };
    }
    case types.SET_CUSTOM_LABEL: {
      const { customLabel } = action.payload;
      return {
        ...state,
        customLabel,
      };
    }
    case types.SET_ENABLE_DATA_LAYER_EVENTS: {
      const { enableDataLayerEvents } = action.payload;
      return {
        ...state,
        enableDataLayerEvents,
      };
    }

    default:
      return state;
  }
}
